export function removeNullOrUndefinedValuesByKeys(
  obj,
  startingObj,
  ...keysToCheck
) {
  return Object.assign(
    startingObj,
    keysToCheck.reduce((acc, k) => (obj[k] ? { ...acc, [k]: obj[k] } : acc), {})
  );
}

// Configurazione automatica dell'ambiente tramite variabili d'ambiente
const getBasePathEnvironment = () => {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return "http://localhost:8080/marketspace";
  } else if (hostname === 'ff-portale.azure.fibercop.local' || hostname === 'www.fibercop.com' ) {
    return "/marketspace";
  }
  else {
    return "https://copertura.fibercop.com/marketspace";
  }
};



/*Configurati i valori direttamente nei container*/
/*Nel file .env c'è localhost*/
/*Se lo avvii in locale si avvia su localhost*/
export const basePathEnvironment = getBasePathEnvironment();


export const endpoints = {
    unsubscribeEmailFromNewsletter: basePathEnvironment + "/newsletter/unsubscribe", //"/marketspace/newsletter/unsubscribe",
    subscribeEmailFromNewsletter: basePathEnvironment + "/newsletter/subscribe", //"/marketspace/newsletter/subscribe",
    confirmEmailAddress: basePathEnvironment + "/newsletter/confirm", //"/marketspace/newsletter/confirm",
    getListAddresses: basePathEnvironment + "/addresses/list", //"/marketspace/addresses/list",
    verifyCoverage: basePathEnvironment + "/addresses/coverage"//"/marketspace/addresses/coverage"
}


export const apiClient = {
  handleErrors(response) {
    if (!response.ok) {
      if (response?.status === 409 && response?.redirected && response.url) {
        window.location = response.url;
      }
      throw response;
    }
    return response;
  },

  customHandleError(response) {
    if (![200, 202, 400].includes(response.status)) {
      throw response;
    }
    return response;
  },

  handleReq(req, body, hasFormData) {
    if (hasFormData) {
      req.body = body;
    } else {
      req.headers = {
        ...req.headers,
        "Content-Type": "application/json"
      };
      if (body != null) {
        req.body = JSON.stringify(body);
      }
    }
    return req;
  },

  get(endpoint, body) {
    const req = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return fetch(endpoint, req)
      .then(apiClient.handleErrors)
      .then((f) => f.json());
  },

  post(endpoint, body, hasFormData = false, expectText = false) {
    const req = {
      method: "POST",
      headers: {
        Accept: "application/json"
      }
    };
    return fetch(endpoint, apiClient.handleReq(req, body, hasFormData))
      .then(apiClient.handleErrors)
      .then((f) => {
        if (expectText) {
          return f.text(); // <-- ritorna stringa, es: "Success"
        } else {
          return f.json(); // <-- ritorna oggetto JSON
        }
      });
  },

  put(endpoint, body, hasFormData = false) {
    const req = {
      method: "PUT",
      headers: {
        Accept: "application/json"
      }
    };
    return fetch(endpoint, apiClient.handleReq(req, body, hasFormData))
      .then(apiClient.handleErrors)
      .then((f) => f.json());
  },

  delete(endpoint) {
    const req = {
      method: "DELETE",
      headers: {
        Accept: "application/json"
      }
    };
    return fetch(endpoint, req).then(apiClient.handleErrors);
  }


};
